import OverlayTrigger, { OverlayTriggerProps } from '@rio-cloud/rio-uikit/OverlayTrigger';
import React, { ReactNode } from 'react';

const OverlayTriggerWithInjectedIntl: React.FC<OverlayTriggerProps & { className?: string; children?: ReactNode }> = ({
    children,
    ...props
}) => {
    const { overlay, ...rest } = props;

    return (
        <OverlayTrigger {...rest} overlay={overlay}>
            {children}
        </OverlayTrigger>
    );
};

export default OverlayTriggerWithInjectedIntl;
